import { FETCH_VACANCY_SUCCESS, VacancyAction } from './actions';
import { VacancyState } from './types';

export const initialVacancyState: VacancyState = {
    name: '',
    videoReference: null,
};

export function vacancyReducer(state: VacancyState = initialVacancyState, action: VacancyAction): VacancyState {
    switch (action.type) {
        case FETCH_VACANCY_SUCCESS:
            return {
                ...state,
                name: action.payload.data.vacancy.name,
                videoReference: action.payload.data.vacancy.videoReference,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/scenes/vacancy/reducer.ts